import { base } from '../base';

export const baseODATA = 'gateway/mainodata';

export const getWithODATA = `${baseODATA}/`;
export const filterFieldCategory = `${base}/FilterFieldCategory/fullfields`;
